import { Link } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import useTitle from '../../hooks/useTitle'

const Welcome = () => {
    const { username, isProductManager, isSystemAnalyst } = useAuth()
    
    useTitle(`Board: ${username}`)

    const content = (
        <div className="text-gray-400 text-[12px] md:text-[15px] flex gap-8 ml-5 mb-[1rem]">
   
            <p><Link to="/dash/tickets">Ticket</Link></p>
            <p><Link to="/dash/tickets/new"> Create New Ticket</Link></p>
        
            {(isProductManager || isSystemAnalyst) && <p><Link to="/dash/users">User</Link></p>}
            {(isProductManager || isSystemAnalyst) && <p><Link to="/dash/users/new">Create New User</Link></p>}
        </div>
       
    )

    return content
}
export default Welcome